import React from 'react';
import Link from 'next/link';

const statsData = [
  { 
    value: "50", 
    suffix: "+", 
    label: "Projects Delivered", 
    description: "Successfully shipped robust web and mobile applications across the globe." 
  },
  { 
    value: "99", 
    suffix: "%", 
    label: "Client Satisfaction", 
    description: "Our clients love the quality, transparency, and speed of our work." 
  },
  { 
    value: "12", 
    suffix: "+", 
    label: "Industries Served", 
    description: "From e-commerce to real estate and healthcare, we've built it all." 
  },
  { 
    value: "5", 
    suffix: "★", 
    label: "Average Rating", 
    description: "Consistently rated 5 stars for our exceptional delivery and support." 
  }
];

export default function ProjectsStats({ data }) {
  const activeStats = data?.stats?.length > 0 ? data.stats : statsData;
  const title = data?.title || "Got an idea? Let's build it.";
  const subtitle = data?.subtitle || "Join 50+ businesses who trusted us with their vision.";
  const btnText = data?.buttonText || "Start your project";

  return (
    <section className="py-20 relative w-full mb-16">
      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-[1100px]">
        {/* Single Premium Glass Panel */}
        <div className="relative rounded-[2.5rem] bg-[#0f0f0fd9] border-[1px] border-[#ffffff1a] pt-12 pb-16 px-6 md:px-12 shadow-2xl overflow-hidden">
          
          {/* Subtle Background Glows inside the panel */}
          <div className="absolute top-0 right-1/4 w-[300px] h-[300px] bg-[#f1833b]/10 blur-[80px] rounded-full pointer-events-none"></div>
          <div className="absolute bottom-0 left-1/4 w-[300px] h-[300px] bg-[#f1833b]/10 blur-[80px] rounded-full pointer-events-none"></div>

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0 lg:divide-x-[1px] lg:divide-[#ffffff1a]">
            {activeStats.map((stat, index) => {
              // Extract numeric value and suffix for styling if provided as a single string
              let val = stat.value || '';
              let suf = stat.suffix || '';
              if (!stat.suffix && val) {
                 const match = val.match(/^([\d.]+)(.*)$/);
                 if (match) {
                   val = match[1];
                   suf = match[2];
                 }
              }
              
              return (
              <div 
                key={index}
                className="flex flex-col items-center text-center px-4 md:px-6 group"
              >
                <h3 className="text-4xl md:text-[44px] font-bold text-white mb-2 tracking-tight flex items-baseline justify-center group-hover:scale-105 transition-transform duration-500">
                  {val}
                  <span className="text-[#f1833b] text-3xl md:text-[32px] ml-1">{suf}</span>
                </h3>
                
                <h4 className="text-[14px] md:text-[15px] font-semibold text-white/90 mb-2 uppercase tracking-wider group-hover:text-[#f1833b] transition-colors duration-300">
                  {stat.label}
                </h4>
                
                <p className="text-[#9ca3af] text-[13px] font-light leading-relaxed max-w-[200px] mx-auto">
                  {stat.description}
                </p>
              </div>
            )})}
          </div>

          {/* Horizontal Divider */}
          <div className="relative z-10 w-full h-[1px] bg-gradient-to-r from-transparent via-[#ffffff2a] to-transparent my-12"></div>

          {/* CTA Section (Merged from IdeaBanner) */}
          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl lg:text-[32px] font-semibold text-white tracking-tight mb-4">
              {title}
            </h2>
            <p className="text-[#9ca3af] mb-8 text-sm md:text-base">
              {subtitle}
            </p>
            <Link 
              href="/contact" 
              className="group inline-flex items-center justify-center bg-[#f1833b] text-black font-semibold text-sm py-3 px-8 rounded-xl transition-all duration-300 shadow-[0_0_15px_rgba(241,131,59,0.25)] hover:shadow-[0_0_25px_rgba(241,131,59,0.4)] hover:bg-white"
            >
              {btnText} 
              <span className="ml-2 font-bold transition-transform duration-300 group-hover:translate-x-1">→</span>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}
